"use client"
import "./globals.scss";
import React from "react";
import Header from "@/components/smile/header/Header";
import Footer from "@/components/smile/footer/Footer";
import {usePathname} from "next/navigation";
import {GoogleTagManager} from "@next/third-parties/google";

export default function Layout({
                                           children,
                                         }: {
  children: React.ReactNode;
}) {
  const style = `.common-layout{ display : none}`

  const pathname = usePathname();
  const splitPath = pathname.split("/");
  const path = splitPath[splitPath.length - 1];

  return (
    <div>
      <style>
        {style}
      </style>
      <main className={`${path} smileLayoutMain`}>
        <Header />
        {children}
        <Footer />
      </main>
      <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GA_ID || ""}/>
    </div>
  );
}
